import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from '../controls/confirm/confirm-modal.component';
import { ConfirmOptions, IConfirmService } from '../core/interfaces/confirm-service.interface';

@Injectable({
	providedIn: 'root'
})
export class ConfirmService implements IConfirmService {
	constructor(private modalService: NgbModal) {}

	async confirm(options: ConfirmOptions | string): Promise<boolean | string> {
		const opts: ConfirmOptions = typeof options === 'string'
			? { message: options }
			: options;

		const modalRef = this.modalService.open(ConfirmModalComponent, {
			centered: true,
			backdrop: 'static'
		});

		const component = modalRef.componentInstance as ConfirmModalComponent;
		component.message = opts.message;
		if (opts.title) component.title = opts.title;
		if (opts.confirmText) component.confirmText = opts.confirmText;
		if (opts.cancelText) component.cancelText = opts.cancelText;
		if (opts.confirmClass) component.confirmClass = opts.confirmClass;
		if (opts.extraText) component.extraText = opts.extraText;
		if (opts.extraClass) component.extraClass = opts.extraClass;

		try {
			const result = await modalRef.result;
			return result; // true oder 'extra'
		} catch {
			return false;
		}
	}

	async confirmDelete(message: string, title = 'Löschen bestätigen'): Promise<boolean> {
		return (await this.confirm({
			title,
			message,
			confirmText: 'Löschen',
			confirmClass: 'btn-danger'
		})) === true;
	}

	async confirmDiscard(message = 'Sollen die Änderungen verworfen werden?'): Promise<boolean> {
		return (await this.confirm({
			title: 'Änderungen verwerfen',
			message,
			confirmText: 'Verwerfen',
			confirmClass: 'btn-warning'
		})) === true;
	}

	async alert(message: string, title = 'Hinweis'): Promise<void> {
		const modalRef = this.modalService.open(ConfirmModalComponent, {
			centered: true
		});

		const component = modalRef.componentInstance as ConfirmModalComponent;
		component.title = title;
		component.message = message;
		component.confirmText = 'OK';
		component.cancelText = '';

		try {
			await modalRef.result;
		} catch {
			// Dialog wurde geschlossen
		}
	}

	async error(message: string, title = 'Fehler'): Promise<void> {
		return this.alert(message, title);
	}

	async warning(message: string, title = 'Warnung'): Promise<void> {
		return this.alert(message, title);
	}
}
